import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import BusinessCopyMachinesWrapper from "@components/layouts/businessCopyMachines";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function businesscopymachinesHome(): ReactElement {
    return (
        <BusinessCopyMachinesWrapper>
            <PrivacyPolicy
                category="BusinessCopyMachines"
                domain="BusinessCopyMachines.com"
            />
        </BusinessCopyMachinesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
